<div class="mx:px-8 mx:py-4 sm:py-3 sm:px-4">
  <div class="flex items-center bread py-[15px]">
    <div [routerLink]="[country+'/order/history']" class="cursor-pointer">{{"HOME_ORDER_HISTORY" | translate}}</div>
    <svg-icon [iconName]="'new/forward-right-small.svg'" [size]="18"></svg-icon>
    <div>{{"DETAIL" | translate}}</div>
  </div>
  <div class="flex items-center cursor-pointer" [routerLink]="[country+'/order/history']">
    <svg-icon [iconName]="'new/back-left.svg'" class="mr-1 ml-[-6px]"></svg-icon>{{"BACK" | translate}}
  </div>
  <div class="mx:flex justify-between ">
    <div class="flex items-center sm:pb-4">
      <div class="w-[8px] h-[20px] bg-primaryBlue mr-2.5"></div>
      <div class="basic font-bold">{{'BASIC_INFO' | translate}}</div>
    </div>
    <div class="mx:flex">
      <div class="default-small-btn mx:mr-4 sm:mb-4"  *ngIf="order?.canCanCel && isDealerPortal" (click)="opeCancelModal('order',order?.orderNo)">
        <svg-icon [iconName]="'new/close-blue.svg'" class="mr-2"></svg-icon>{{"CANCEL_ORDER" | translate}}</div>
      <div class="primary-small-btn sm:mb-4" (click)="orderAgain(order?.orderItemInfoVOList)"><svg-icon
          [iconName]="'new/cart.svg'" class="mr-2"></svg-icon>{{"ORDER_AGAIN" | translate}}</div>
    </div>
    <!-- <ng-template #cancelOrderTem>
      <div class="cancel_title">{{'CONFIRM_ORDER_CANCELLATION' | translate}}</div>
      <div class="operation"><span class="btn mr20" (click)="cancelOrder(order?.orderNo)">{{'CONFIRM' |
          translate}}</span><span class="btn" (click)="order.visible=false">{{'CANCEL' | translate}}</span>
      </div>
    </ng-template> -->
  </div>
  <div class="info-wrap mx:flex justify-between flex-wrap gap-y-[15px]">
    <div>
      <div class="flex mb15">
        <div class="info-title font-bold">{{"ORDER_NO" | translate}}</div>
        <div>{{order?.orderNo}}</div>
      </div>
      <div class="flex mb15">
        <div class="info-title font-bold">{{"PO_No" | translate}}</div>
        <div class="info-text">{{order?.poNo}}</div>
      </div>
      <div class="flex mb15">
        <div class="info-title font-bold"> {{"ORDER_DATE" | translate}}</div>
        <div>{{order?.orderCreateDate}}</div>
      </div>
      <div class="flex">
        <div class="info-title font-bold">{{"STATUS" | translate}}</div>
        <div class="status" [style.color]="getColor(order?.realOrderStatus)">{{order?.realOrderStatusDisplayName}}
        </div>
      </div>
    </div>
    <div class="sm:mt-[15px]">
      <div class="flex mb15">
        <div class="info-title font-bold">{{"GROSS_VALUE" | translate}}</div>
        <div>{{order?.currency}} {{order?.totalAmount | number : "1.2-2" }}</div>
      </div>
      <div class="flex mb15">
        <div class="info-title font-bold">{{"NET_VALUE" | translate}}</div>
        <div>{{order?.currency}} {{order?.netValue | number : "1.2-2" }}</div>
      </div>
      <div class="flex">
        <div class="info-title font-bold"> {{"TAX" | translate}}</div>
        <div>{{order?.currency}} {{order?.taxAmount | number : "1.2-2" }}</div>
      </div>
    </div>
    <div class="sm:mt-[15px]">
      <div class="flex mb15">
        <div class="info-title  font-bold">{{"CART_SHIPPING_ADDRESS" | translate}}</div>
        <div class="address">{{order?.shipToAddress}}</div>
      </div>
    </div>
    <div>
      <!-- <div class="flex mb15">
        <div class="info-title font-bold">{{"SHIPPING_DIMENSION" | translate}}</div>
        <div>Volume:{{order?.totalVolume}}{{order?.unitVolume}}
        </div>
      </div> -->
      <div class="flex mb15">
        <div class="info-title font-bold">{{"SOLD_TO_NO" | translate}}</div>
        <div>{{order?.customerId}}</div>
      </div>
      <div class="flex mb15">
        <div class="info-title font-bold">{{"CART_PROCESS_ORDER" | translate}}</div>
        <div>{{order?.orderTypeDisplayName || '--'}}</div>
      </div>
      <div class="flex mb15">
        <div class="info-title font-bold">{{"PAYMENT_TERMS" | translate}}</div>
        <div class="payment">{{order?.paymentCondition}}</div>
      </div>
      <!-- <div class="flex">
              <div class="info-title">Customer ID</div>
              <div class="info-text">{{ order?.customerId }}</div>
          </div> -->
    </div>

  </div>
  <div class="flex items-center sm:pb-4 mx:pb-8">
    <div class="w-[8px] h-[20px] bg-primaryBlue mr-2.5"></div>
    <div class="basic font-bold">{{
      'ITEM_DETAIL' | translate : { total:itemList.length}
      }}</div>
  </div>
  <div class="font16-w700 flex mb20">{{'COMPLETED_ITEMS' | translate}}<nz-progress class="progress"
      [nzPercent]="getPercent(order?.totalCompletedQuantity,order?.totalOrderQuantity)"
      [nzShowInfo]="false"></nz-progress><span>{{order?.totalCompletedQuantity}} / {{order?.totalOrderQuantity}}</span>
  </div>
  <div class="result-table">
    <nz-table #fixedTable [nzScroll]="{ x: 'max-content' }" [nzFrontPagination]="false" [nzShowPagination]="false"
      [nzData]="itemList">
      <thead>
        <tr>
          <th nzWidth="120px">
            <div class="flex-v-center">
              <span class="arrow_block"></span>{{"ITEM" | translate}}
            </div>
          </th>
          <th nzWidth="220px">{{"MATERIAL" | translate}}</th>
          <th nzWidth="130px"> {{"QUANTITY" | translate}}</th>
          <th nzWidth="130px"> {{"MOQ" | translate}}</th>
          <th nzWidth="180px">{{"NET_PRICE" | translate}}</th>
          <th nzWidth="180px">{{"NET_VALUE" | translate}}</th>
          <th nzWidth="160px">{{"ADD_DATE" | translate}}</th>
          <th nzWidth="160px">{{"CONFIRMED_DATE" | translate}} </th>
          <th nzWidth="160px">{{"DIRECT_DELIVERY_DATE" | translate}}</th>
          <th nzWidth="190px">{{"DELIVERY_DATE_ORDER" | translate}}</th>
          <th nzWidth="180px">{{"ITEM_STATUS" | translate}}</th>
          <th nzWidth="262px">{{"DELIVERY_PROGRESS" | translate}}</th>
          <th nzWidth="150px">{{"CART_PROCESS_ORDER" | translate}}</th>
          <th nzWidth="120px">{{ "ASN_No" | translate}}</th>
          <th nzWidth="150px">{{ "UPDATE_TIME_ORDER" | translate}}</th>
          <th nzRight nzWidth="80px"> {{"ACTION" | translate}}</th>
        </tr>
      </thead>
      <tbody class="order">
        <ng-container *ngFor="let data of itemList">
          <tr>
            <td [nzExpand]="expandSet.has(data.orderNo+data.itemNo)">
              <div class="flex">
                <span class="arrow_block" *ngIf="data.deliveryInfoVOList.length!=0">
                  <span *ngIf="expandSet.has(data.orderNo+data.itemNo) && data.deliveryInfoVOList.length> 0"
                    class="up-icon" (click)="onExpandChange(data.orderNo+data.itemNo,false)">
                  </span>
                  <span *ngIf="!expandSet.has(data.orderNo+data.itemNo) && data.deliveryInfoVOList.length> 0"
                    class="down-icon" (click)="onExpandChange(data.orderNo+data.itemNo, true)">
                  </span>
                </span>

                <span class="arrow_block" *ngIf="data.deliveryInfoVOList.length==0"></span>
                <span>{{data.itemNo}}</span>
              </div>
            </td>
            <td>
              <div class="good flex">
                <div>
                  <div class="font-bold">{{data.orderedMaterialNumber}}</div>
                  <div>{{data.enteredMaterialNumber}}</div>
                  <div>{{data.productDescription}}</div>
                </div>
              </div>
            </td>
            <td> {{data.orderQuantity | number : "1.0-0" }} {{data.quantityUnit}}</td>
            <td> {{data.moq==0?'':data.moq}}</td>
            <td>{{data.currency}} {{data.unitPrice | number : "1.2-2" }}</td>
            <td>{{data.currency}} {{data.totalNetValue | number : "1.2-2" }}</td>
            <td>{{data.customerRequestDeliveryDate}}</td>
            <td>
              <div class="flex-v-center">
                <div *ngIf="data.deliveryScheduleVOList.length==1">
                  <span class="info-title">{{ data.deliveryScheduleVOList[0].confirmedDeliveryDate }}</span>
                </div>
                <div class="flex-v-center" *ngIf="data.deliveryScheduleVOList.length > 1">
                  <span class="info-title">{{ data.deliveryScheduleVOList[0].confirmedDeliveryDate }}</span>
                  <span>{{data.deliveryScheduleVOList[0].confirmedQuantity}}</span>
                    <svg-icon [iconName]="'new/arrow.svg'" style="line-height: 10px;margin-top:-2px;" [size]="10" nz-popover [nzPopoverPlacement]="'top'"
                    [nzPopoverContent]="deliveryDateTemplate" class="ml6"></svg-icon>
                </div>
              </div>
              <ng-template #deliveryDateTemplate>
                <div>
                  <div class="flex" *ngFor="let delivery of data.deliveryScheduleVOList;">
                    <span class="info-title">{{delivery.confirmedDeliveryDate}}</span>
                    <span>{{delivery.confirmedQuantity}}</span>
                  </div>
                </div>
              </ng-template>
            </td>
            <td>{{data.asnCreateDate}}</td>
            <td>{{data.ztpInboundDeliveryDate}}</td>
            <td>
              <custom-tag [content]="data.realItemStatusDisplayName"
                [backgroundColor]="getColorByStatus(data.realItemStatus,true,false)"
                [fontColor]="getColorByStatus(data.realItemStatus,false,false)"
                [borderColor]="getColorByStatus(data.realItemStatus,false,true)"></custom-tag>
            </td>
            <td>
              <div class="flex-v-center">
                <app-progress *ngIf="data.statisticsMap" [statisticsMap]="data.statisticsMap"
                  [cancelled]="data.realItemStatus=='Cancelled'"></app-progress>
              </div>
            </td>
            <td>{{data.orderTypeDisplayName}}</td>
            <td>{{data.externalId}}</td>
            <td>{{data.batch}}</td>
            <td nzRight>
              <div class="cursor-pointer flex-center">
                <svg-icon *ngIf="data?.canCanCel && isDealerPortal" [title]="'CANCEL_ITEM'|translate" 
                  [iconName]="'new/digi_cancel.svg'"  class="cursor-pointer" [size]="20" (click)="opeCancelModal('item',data)"></svg-icon>
              </div>
            </td>
          </tr>
          <tr [nzExpand]="expandSet.has(data.orderNo+data.itemNo)">
            <div *ngIf="data.deliveryInfoVOList.length> 0; else noDeliveryInfo">
              <div class="item-wrap" *ngFor="let deliveryInfo of data.deliveryInfoVOList; let i = index">
                <div class="flex-between">
                  <div class="item">
                    <span>{{'DELIVERY_NO' | translate}}</span>
                    <span class="item-value">{{deliveryInfo.dnNo }}</span>
                  </div>
                  <div class="qty-item">
                    <span>{{'QTY' | translate}}</span>
                    <span class="item-value">{{deliveryInfo.dnQuantity | number : "1.0-0"}}</span>
                  </div>
                  <div class="status-item">
                    <span>{{deliveryInfo.realDeliveryStatusDisplayName}}</span>
                  </div>
                  <ng-template #statusTemplate>
                    <log-process [status]="deliveryInfo.realDeliveryStatus"
                      [deliveryList]="deliveryInfo.deliveryNoticeInfoHistoryList"></log-process>
                  </ng-template>
                  <div class="item">
                    <span>{{'PLANNED_DELIVERY_DATE' | translate}}</span>
                    <span class="item-value">{{deliveryInfo.dnCreateDate}}</span>
                  </div>
                  <div class="track-item" >
                    <span>{{'TRACKING_NO' | translate}}</span>
                    <span class="link ml20" (click)="goTracking(deliveryInfo.trackingNo)">{{deliveryInfo.trackingNo}}</span>
                  </div>
                  <div class="ship-item">
                    <span>{{'INVOICE_NUMBER' | translate}}</span>
                    <span class="item-value">{{deliveryInfo.billingNo}}</span>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noDeliveryInfo>
              <div class="no-delivery-info">
                {{'NO_CREATED_DELIVERY_NOTE' | translate}}
              </div>
            </ng-template>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
  <nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" [nzClosable]="false" (nzOnCancel)="isVisible=false" (nzOnOk)="handleCancel()">
    <ng-template #modalTitle>
      <div class="flex justify-between">
        <span class="font-bold text-base">{{ cancelType == 'order' ? ('CANCEL_ORDER' | translate) : ('CANCEL_ITEM' | translate) }}
        </span>
        <svg-icon [iconName]="'new/close.svg'" class="cursor-pointer fr" (click)="isVisible=false"></svg-icon>
      </div>    
    </ng-template>
    <ng-container *nzModalContent>
      <p class="my-6">{{ cancelType == 'order' ? ('CONFIRM_ORDER_CANCELLATION' | translate) : ('CONFIRM_CANCELLATION' | translate) }}
      </p>
    </ng-container>
  </nz-modal>

</div>